import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgDashboard = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.46582 0.499481H14.5342C15.3408 0.499481 16 1.15884 15.9971 1.96512V6.05258C15.9971 6.85886 15.3379 7.51822 14.5312 7.51822H1.46582C0.65918 7.51822 0 6.85886 0 6.05258V1.96512C0 1.15884 0.65918 0.499481 1.46582 0.499481ZM2 5.52133H14V2.52133H2V5.52133Z" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5342 9.47763H1.46582C0.65918 9.47763 0 10.137 0 10.9464V15.0339C0 15.8401 0.65918 16.4995 1.46582 16.4995H14.5312C15.3379 16.4995 15.9971 15.8401 15.9971 15.0339V10.9464C16 10.137 15.3408 9.47763 14.5342 9.47763ZM2 14.4995H14V11.4995H2V14.4995Z" })
] });
const ForwardRef = /* @__PURE__ */ forwardRef(SvgDashboard);
export { ForwardRef as ReactComponent };
import assetUrl from "/home/runner/work/UpstriveEducation-Teacher/UpstriveEducation-Teacher/src/assets/svg/dashboard.svg?url";
export default assetUrl;
